import React, { useRef, useState, useEffect } from "react";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import "./FramedImage.css"; // Import the CSS file

const FramedImage = ({ img }) => {
  const nodeRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.3 } // Trigger when 30% of the image is visible
    );

    if (nodeRef.current) {
      observer.observe(nodeRef.current);
    }

    return () => {
      if (nodeRef.current) {
        observer.unobserve(nodeRef.current);
      }
    };
  }, []);

  return (
    <div
      ref={nodeRef}
      className={`image-container ${isVisible ? "visible" : ""}`}
    >
      <div className="fade-frame">
        {/* Bottom Left Frame */}
        <div className="frame bottom-left"></div>
        <div className="frame bottom-left-2"></div>

        {/* Top Right Frame */}
        <div className="frame top-right"></div>
        <div className="frame top-right-2"></div>

        {/* Image */}
        <img src={img} alt="Image" className="image" width="200" height="200" />
      </div>
    </div>
  );
};

export default FramedImage;
